"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionSettings = instanceOfCompetitionSettings;
exports.CompetitionSettingsFromJSON = CompetitionSettingsFromJSON;
exports.CompetitionSettingsFromJSONTyped = CompetitionSettingsFromJSONTyped;
exports.CompetitionSettingsToJSON = CompetitionSettingsToJSON;
exports.CompetitionSettingsToJSONTyped = CompetitionSettingsToJSONTyped;
var Competition_1 = require("./Competition");
var Ace_1 = require("./Ace");
var ChatProvider_1 = require("./ChatProvider");
var SignUpMode_1 = require("./SignUpMode");
var NetworkKind_1 = require("./NetworkKind");
/**
 * Check if a given object implements the CompetitionSettings interface.
 */
function instanceOfCompetitionSettings(value) {
    if (!('competition' in value) || value['competition'] === undefined)
        return false;
    if (!('teamSizeMin' in value) || value['teamSizeMin'] === undefined)
        return false;
    if (!('teamSizeMax' in value) || value['teamSizeMax'] === undefined)
        return false;
    if (!('representSameCommunity' in value) || value['representSameCommunity'] === undefined)
        return false;
    return true;
}
function CompetitionSettingsFromJSON(json) {
    return CompetitionSettingsFromJSONTyped(json, false);
}
function CompetitionSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'competition': (0, Competition_1.CompetitionFromJSON)(json['competition']),
        'teamSizeMin': json['teamSizeMin'],
        'teamSizeMax': json['teamSizeMax'],
        'requiredNetwork': json['requiredNetwork'] == null ? undefined : (0, NetworkKind_1.NetworkKindFromJSON)(json['requiredNetwork']),
        'required2ndNetwork': json['required2ndNetwork'] == null ? undefined : (0, NetworkKind_1.NetworkKindFromJSON)(json['required2ndNetwork']),
        'requireNetworkUpfront': json['requireNetworkUpfront'] == null ? undefined : json['requireNetworkUpfront'],
        'requiredPermit': json['requiredPermit'] == null ? undefined : json['requiredPermit'],
        'representSameCommunity': json['representSameCommunity'],
        'signUpMode': json['signUpMode'] == null ? undefined : (0, SignUpMode_1.SignUpModeFromJSON)(json['signUpMode']),
        'requiredOrganization': json['requiredOrganization'] == null ? undefined : json['requiredOrganization'],
        'reportTimerMinutes': json['reportTimerMinutes'] == null ? undefined : json['reportTimerMinutes'],
        'supportingCause': json['supportingCause'] == null ? undefined : json['supportingCause'],
        'channelCloseDelaySeconds': json['channelCloseDelaySeconds'] == null ? undefined : json['channelCloseDelaySeconds'],
        'discordIntegrationId': json['discordIntegrationId'] == null ? undefined : json['discordIntegrationId'],
        'donationGoal': json['donationGoal'] == null ? undefined : json['donationGoal'],
        'participantInquiry': json['participantInquiry'] == null ? undefined : json['participantInquiry'],
        'entryRepresentingOptional': json['entryRepresentingOptional'] == null ? undefined : json['entryRepresentingOptional'],
        'hideRegistration': json['hideRegistration'] == null ? undefined : json['hideRegistration'],
        'matchTicker': json['matchTicker'] == null ? undefined : json['matchTicker'],
        'chatProvider': json['chatProvider'] == null ? undefined : (0, ChatProvider_1.ChatProviderFromJSON)(json['chatProvider']),
        'allowParentUsers': json['allowParentUsers'] == null ? undefined : json['allowParentUsers'],
        'allowChildUsers': json['allowChildUsers'] == null ? undefined : json['allowChildUsers'],
        'allowCommunityManagedUsers': json['allowCommunityManagedUsers'] == null ? undefined : json['allowCommunityManagedUsers'],
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function CompetitionSettingsToJSON(json) {
    return CompetitionSettingsToJSONTyped(json, false);
}
function CompetitionSettingsToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': value['owner'],
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'acesInheriting': value['acesInheriting'],
        'competition': (0, Competition_1.CompetitionToJSON)(value['competition']),
        'teamSizeMin': value['teamSizeMin'],
        'teamSizeMax': value['teamSizeMax'],
        'requiredNetwork': (0, NetworkKind_1.NetworkKindToJSON)(value['requiredNetwork']),
        'required2ndNetwork': (0, NetworkKind_1.NetworkKindToJSON)(value['required2ndNetwork']),
        'requireNetworkUpfront': value['requireNetworkUpfront'],
        'requiredPermit': value['requiredPermit'],
        'representSameCommunity': value['representSameCommunity'],
        'signUpMode': (0, SignUpMode_1.SignUpModeToJSON)(value['signUpMode']),
        'requiredOrganization': value['requiredOrganization'],
        'reportTimerMinutes': value['reportTimerMinutes'],
        'supportingCause': value['supportingCause'],
        'channelCloseDelaySeconds': value['channelCloseDelaySeconds'],
        'discordIntegrationId': value['discordIntegrationId'],
        'donationGoal': value['donationGoal'],
        'participantInquiry': value['participantInquiry'],
        'entryRepresentingOptional': value['entryRepresentingOptional'],
        'hideRegistration': value['hideRegistration'],
        'matchTicker': value['matchTicker'],
        'chatProvider': (0, ChatProvider_1.ChatProviderToJSON)(value['chatProvider']),
        'allowParentUsers': value['allowParentUsers'],
        'allowChildUsers': value['allowChildUsers'],
        'allowCommunityManagedUsers': value['allowCommunityManagedUsers'],
        'illegal': value['illegal'],
    };
}
